import { useState } from "react";
import FileItem from "components/shared/FileItem";

const FileList = (props) => {
	const {
		files,
		totalUploadSizeMessage,
		removeFile,
		removeText,
		inlineErrors,
		setFileRemoved
	} = props;
	const mainClass = "help-file-list";
	const [hasError, setHasError] = useState(false);
	return (
		<div className={` ${mainClass} ${hasError ? ` ${mainClass}--error` : ""} `}>
			<div className={`${mainClass}__content`}>
				<div className={`${mainClass}__content__advise`}>
					<label
						className={`${mainClass}__content__advise__text`}
						dangerouslySetInnerHTML={{
							__html: totalUploadSizeMessage,
						}}
					></label>
				</div>
				{files.map((file, index) => {
					return (
						<FileItem
							index={index}
							removeText={removeText}
							removeFile={removeFile}
							setHasError={setHasError}
							setFileRemoved={setFileRemoved}
							parentClass={`${mainClass}__content`}
							key={file.filename}
							inlineErrors={inlineErrors}
							{...file}
							
						/>
					);
				})}
			</div>
		</div>
	);
};

export default FileList;
